import type { Deal } from '../lib/types';
import { User, MessageSquare, CheckSquare } from 'lucide-react'; // Added icons
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip'; // Assuming shadcn/ui tooltip path

interface KanbanCardProps {
  deal: Deal;
}

export function KanbanCard({ deal }: KanbanCardProps) {
  return (
    <div className="bg-white p-3 rounded-md shadow-sm border border-gray-200 mb-3">
      <h3 className="font-semibold text-sm text-gray-800 mb-1">{deal.title}</h3>
      {deal.orgName && <p className="text-xs text-gray-500">{deal.orgName}</p>}
      {deal.contactName && <p className="text-xs text-gray-500 mb-1">{deal.contactName}</p>}

      {/* Display value and currency, handling optionality */}
      {/* <p className="text-xs font-medium text-gray-700 mb-1">
        {deal.currency || 'N/A'} {(deal.value || 0).toLocaleString('da-DK')}
      </p> */}

      {/* Display next activity subject if available */}
      {deal.nextActivitySubject && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <p className="text-xs text-gray-600 italic truncate mb-2 cursor-default">
                Næste: {deal.nextActivitySubject}
              </p>
            </TooltipTrigger>
            <TooltipContent>
              <p>{deal.nextActivitySubject}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}

      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <div className="flex items-center" title={`Owner: ${deal.ownerName || 'N/A'}`}>
            <User className="h-4 w-4 text-gray-400" />
            {/* Optionally display owner name if design allows, or keep for tooltip */}
            {/* <span className="text-xs text-gray-500">{deal.ownerName}</span> */}
          </div>
          {typeof deal.notesCount === 'number' && (
            <div
              className="flex items-center text-xs text-gray-500"
              title={`${deal.notesCount} notes`}
            >
              <MessageSquare className="h-3 w-3 mr-0.5" />
              {deal.notesCount}
            </div>
          )}
          {typeof deal.activityCount === 'number' && (
            <div
              className="flex items-center text-xs text-gray-500"
              title={`${deal.activityCount} activities`}
            >
              <CheckSquare className="h-3 w-3 mr-0.5" />
              {deal.activityCount}
            </div>
          )}
        </div>
        {/* This is a placeholder for the red icon with chevron. 
            You might need specific logic to show this based on deal status. */}
        {/* <div className="bg-red-500 rounded-full h-5 w-5 flex items-center justify-center">
          <ChevronLeft className="h-3 w-3 text-white" />
        </div> */}
      </div>
    </div>
  );
}
